import { formatMessage } from "lib/globalize-util";
import { Tab, Tabs } from "material-ui/Tabs";
import * as React from "react";
import { TabValues } from "./constants";
import { DATATEST } from "constants/integration";
import classNames from "classnames";

interface IProps {
    onChangeTab: (value: TabValues) => void;
    tabValue: TabValues;
    isImportDoorAttributesEnabled: boolean;
}
export const ManageAllocationDimensionTabs: React.FunctionComponent<IProps> = ({
    onChangeTab,
    isImportDoorAttributesEnabled,
    tabValue,
}) => {
    const tabs = [
        {
            value: TabValues.AddOrEditAttributes,
            dataTest: DATATEST.ASSORTMENTS.ALLOCATION_DIMENSIONS.TABS.EDIT_DOOR_GROUPINGS,
            label: formatMessage("Edit door groupings"),
        },
    ];

    if (isImportDoorAttributesEnabled) {
        tabs.push({
            value: TabValues.ImportAttributes,
            dataTest: DATATEST.ASSORTMENTS.ALLOCATION_DIMENSIONS.TABS.IMPORT_DOOR_GROUPINGS,
            label: formatMessage("Import door groupings"),
        });
    }
    // Tabs should only display when there is more than 1 tab
    if (tabs.length <= 1) {
        return null;
    }

    return (
        <Tabs value={tabValue} onChange={onChangeTab}>
            {tabs.map(({ value, dataTest, label }) => (
                <Tab
                    key={value}
                    className={classNames("tab", { selected: tabValue === value })}
                    label={label}
                    value={value}
                    data-test={dataTest}
                />
            ))}
        </Tabs>
    );
};
